import { RouteConfig } from 'vue-router';

const BASE_PATH = 'views/government/dataCollection';
const dataCollection: Array<RouteConfig> = [
    {
        path: 'data-collection',
        name: 'dataCollection',//大屏数据采集
        redirect: {name: 'startPage'},
        component: () => import(`@/views/government/Main.vue`),
        children: [
            {
                path: 'start-page',
                name: 'startPage',
                meta: {
                    index: '1-0',
                    noBottom:true
                },
                component: () => import(`@/${BASE_PATH}/startPage/index.vue`),
            },
            {
                path: 'demonstration',
                name: '智种示范',
                meta: {
                    index: '1-1',
                },
                component: () => import(`@/${BASE_PATH}/demonstration/index.vue`),
            },
            {
                path: 'smartIoT',
                name: 'smartIoT',//智慧物联
                redirect: { name: '物联总览' },
                component: () => import(`@/views/government/Main.vue`),
                children: [
                    {
                        path: 'ioTOverview',
                        name: '物联总览',
                        component: () => import(`@/${BASE_PATH}/smartIoT/ioTOverview/index.vue`),
                        meta: {
                            index: '1-2-1',
                        },
                    },
                ],
            },
            {
                path: 'goodAgriculture',
                name: 'goodAgriculture',//良好农业
                redirect: {name: 'annualTrend'},
                component: () => import(`@/views/government/Main.vue`),
                children: [
                    {
                        path: 'projectList',
                        name: 'projectList',//项目列表
                        component: () => import(`@/${BASE_PATH}/goodAgriculture/plantingDetails/projectList.vue`),
                        meta: {
                            index: '1-3-1',
                        },
                    },
                    {
                        path: 'plantingDetails',
                        name: 'plantingDetails',//种植详情
                        component: () => import(`@/${BASE_PATH}/goodAgriculture/plantingDetails/index.vue`),
                        meta: {
                            index: '1-3-1',
                        },
                    },
                    {
                        path: 'fieldList',
                        name: 'fieldList',//田块列表
                        component: () => import(`@/${BASE_PATH}/goodAgriculture/fieldDetails/fieldList.vue`),
                        meta: {
                            index: '1-3-2',
                        },
                    },
                    {
                        path: 'fieldDetails',
                        name: 'fieldDetails',//田块详情
                        component: () => import(`@/${BASE_PATH}/goodAgriculture/fieldDetails/index.vue`),
                        meta: {
                            index: '1-3-2',
                            noBottom:true
                        },
                    },
                    {
                        path: 'annualTrend',
                        name: 'annualTrend',//年度趋势
                        component: () => import(`@/${BASE_PATH}/goodAgriculture/annualTrend/index.vue`),
                        meta: {
                            index: '1-3-3',
                        },
                    },
                ],
            },
            {
                path: 'promotion',
                name: '市场推广',
                redirect: {name: '常规稻繁种'},
                component: () => import(`@/views/government/Main.vue`),
                children: [
                    {
                        path: 'regular',
                        name: '常规稻繁种',
                        component: () => import(`@/${BASE_PATH}/promotion/regular/index.vue`),
                        meta: {
                            index: '1-4-1',
                            noBottom:true
                        },
                    },
                    {
                        path: 'hybrid',
                        name: '杂交稻智种',
                        component: () => import(`@/${BASE_PATH}/promotion/hybrid/index.vue`),
                        meta: {
                            index: '1-4-2',
                            noBottom:true
                        },
                    },
                ],
            },
            {
                path: 'smallBreedTrials',
                name: 'smallBreedTrials',//小品种试验
                meta: {
                    index: '1-5',
                    noBottom:true
                },
                component: () => import(`@/${BASE_PATH}/smallBreedTrials/index.vue`),
            },
            {
                path: 'commonProsperity',
                name: '种业共富',
                meta: {
                    index: '1-6',
                },
                component: () => import(`@/${BASE_PATH}/commonProsperity/index.vue`),
            },
        ],
    },
];
export default dataCollection;